function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import cls from 'classnames';
import React, { memo } from 'react';
import { PLAYER_KEY } from '../config/player';
import SORTABLE_CONFIG from '../config/sortable';

var AudioListsPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(AudioListsPanel, _React$Component);

  var _super = _createSuper(AudioListsPanel);

  function AudioListsPanel() {
    _classCallCheck(this, AudioListsPanel);

    return _super.apply(this, arguments);
  }

  _createClass(AudioListsPanel, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.playId !== this.props.playId && prevProps.visible && this.props.visible) {
        this.scrollIntoView();
      }
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var _this$props = this.props,
          playId = _this$props.playId,
          visible = _this$props.visible,
          isMobile = _this$props.isMobile;

      var _ref = this.ref || {},
          _ref$children = _ref.children,
          children = _ref$children === void 0 ? [] : _ref$children;

      if (!isMobile && visible) {
        for (var i = 0; i < children.length; i++) {
          var item = children[i];

          if (item.id === playId) {
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
            break;
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          audioLists = _this$props2.audioLists,
          onCancel = _this$props2.onCancel,
          onDelete = _this$props2.onDelete,
          onPlay = _this$props2.onPlay,
          playId = _this$props2.playId,
          loading = _this$props2.loading,
          panelToggleAnimate = _this$props2.panelToggleAnimate,
          glassBg = _this$props2.glassBg,
          remove = _this$props2.remove,
          removeId = _this$props2.removeId,
          isMobile = _this$props2.isMobile,
          locale = _this$props2.locale,
          icon = _this$props2.icon,
          playing = _this$props2.playing;
      return /*#__PURE__*/React.createElement("div", {
        className: cls('audio-lists-panel', panelToggleAnimate, {
          'audio-lists-panel-mobile': isMobile || window.innerWidth < 800,
          'glass-bg': glassBg
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "audio-lists-panel-header",
        ref: function ref(_ref2) {
          _this.headerRef = _ref2;
          return 1;
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: "audio-lists-panel-header-title"
      }, /*#__PURE__*/React.createElement("span", null, locale.playListsText, " / "), /*#__PURE__*/React.createElement("span", {
        className: "audio-lists-panel-header-num"
      }, audioLists.length), /*#__PURE__*/React.createElement("span", {
        className: "audio-lists-panel-header-actions"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "audio-lists-panel-header-locate-btn",
        title: "Locate the playing song",
        onClick: function onClick() {
          return _this.scrollIntoView();
        }
      }, icon.play), /*#__PURE__*/React.createElement("span", {
        className: "audio-lists-panel-header-line"
      })), /*#__PURE__*/React.createElement("span", {
        className: "audio-lists-panel-header-close-btn",
        title: locale.closeText,
        onClick: onCancel
      }, isMobile ? icon.packUpPanelMobile : icon.close)))), /*#__PURE__*/React.createElement("div", {
        className: cls('audio-lists-panel-content', {
          'no-content': audioLists.length < 1
        })
      }, audioLists.length >= 1 ? /*#__PURE__*/React.createElement("ul", {
        className: !isMobile ? SORTABLE_CONFIG.selector : '',
        ref: function ref(_ref3) {
          _this.ref = _ref3;
          return 1;
        }
      }, audioLists.map(function (audio) {
        var name = audio.name,
            singer = audio.singer;
        var audioId = audio[PLAYER_KEY];
        var isCurrentPlaying = playId === audioId;
        return /*#__PURE__*/React.createElement("li", {
          key: audioId,
          id: audioId,
          title: !playing ? locale.clickToPlayText : isCurrentPlaying ? locale.clickToPauseText : locale.clickToPlayText,
          className: cls('audio-item', {
            playing: isCurrentPlaying
          }, {
            pause: !playing
          }, {
            remove: removeId === audioId
          }),
          onClick: function onClick() {
            onPlay(audioId);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "group player-status"
        }, /*#__PURE__*/React.createElement("span", {
          className: "player-icons"
        }, isCurrentPlaying && loading ? icon.loading : isCurrentPlaying ? playing ? icon.pause : icon.play : undefined)), /*#__PURE__*/React.createElement("span", {
          className: "group player-name",
          title: name
        }, name), /*#__PURE__*/React.createElement("span", {
          className: "group player-singer",
          title: singer
        }, singer), remove && /*#__PURE__*/React.createElement("span", {
          className: "group player-delete",
          title: locale.clickToDeleteText(name),
          onClick: onDelete(audioId)
        }, icon.close));
      })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, icon.empty), /*#__PURE__*/React.createElement("span", {
        className: "no-data"
      }, locale.emptyText || locale.notContentText))));
    }
  }]);

  return AudioListsPanel;
}(React.Component);

export default /*#__PURE__*/memo(AudioListsPanel);